module.exports = __webpack_public_path__ + "static/media/t-rex-graficas.f10a5525.svg";